import { type FC } from "react";
import * as styles from "@clientFrontend/features/scout/components/MultiSelectModal/styles.css";
import {
  type selectedItemProps,
  type ActionProps,
} from "@clientFrontend/features/scout/components/MultiSelectModal/modules";

type Props = {
  formState: selectedItemProps;
  dispatchFormState: React.Dispatch<ActionProps>;
};

export const SelectedList: FC<Props> = ({ formState, dispatchFormState }) => {
  return (
    <ul className={styles.selectedLists}>
      {Object.entries(formState).map(([value, { name }]) => (
        <li className={styles.selectedList} key={value}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={() =>
              dispatchFormState({
                type: "unSelectValue",
                value,
              })
            }
          >
            <i className="icon-cancel" />
          </button>
          {name}
        </li>
      ))}
    </ul>
  );
};
